import type { DomainPostBody } from '../../../api/generated/pap';

/**
 * The "empty" UUID the PAP domain PATCH endpoint interprets as "clear the
 * Identity Provider" (see `domainPatchBody.identityProviderId` in the spec:
 * "Set to Nil UUID to clear."). Omitting the field on a PATCH leaves the
 * existing Identity Provider untouched, so clearing must send this explicitly.
 */
export const NIL_UUID = '00000000-0000-0000-0000-000000000000';

interface BuildDomainPayloadArgs {
  isEdit: boolean;
  /** The domain name to send (already resolved by the caller). */
  name: string;
  /** The selected Identity Provider id, or '' when none is selected/cleared. */
  identityProviderId: string;
}

/**
 * Builds the request body for adding or updating a Domain.
 *
 * On **edit**, an empty selection means the user cleared the Identity Provider,
 * which must be sent as {@link NIL_UUID} (a PATCH omission would be a no-op).
 * On **add**, an empty selection simply omits the field (there is nothing to
 * clear on create).
 */
export function buildDomainPayload({
  isEdit,
  name,
  identityProviderId,
}: BuildDomainPayloadArgs): DomainPostBody {
  return {
    name,
    identityProviderId: isEdit ? identityProviderId || NIL_UUID : identityProviderId || undefined,
  };
}
